import axios from 'axios';
import Environment from '../../utils/Environment';

interface SubmitDataParams {
    org: string;
    env: string;
    group: string;
    subGroup: string;
    data: { [key: string]: string }[];
}

export const submitTableData = async (params: SubmitDataParams): Promise<any> => {
    const { org, group, subGroup, data } = params; 
    const baseURL = Environment.getSubmitTableDataAPI();
    
    const jsonMessage = JSON.stringify({
        data: data
    });
    

    
    // Create FormData
    const formData = new FormData();
    formData.append('jsonMessage', jsonMessage);
    
    try {
        const response = await axios.post(baseURL, formData, {
            params: {
                dcCode: org,
                group: group,
                sub: subGroup
            },
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });        
        return response.data;
    } catch (error: any) {
        throw error;
    }
};
